import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"

import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import DataTableAvisTest from "./DataTableAvisTest"
import AddTestLibre from "./AddTestLibre"
import TestEmploi from "./TestEmploi"

const AvisTest = props => {
  const [section, setSection] = useState(1)

  const back = () => {
    setSection(1)
  }
  var url = window.location.href
  var array = url.split("/")
  var id = array[4]
  const renderBlock = section => {
    if (section === 1) {
      return <DataTableAvisTest type={id} />
    } else if (section === 2) {
      return <AddTestLibre type={id} setSection={setSection} back={back} />
    } else if (section === 3) {
      return <TestEmploi setSection={setSection} back={back} type={id} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("DS")}</title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("DS")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {props.t("Ajouter DS libre")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 3,
                  })}
                  onClick={() => {
                    setSection(3)
                  }}
                >
                  {props.t("Ajouter DS même seance")}
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

AvisTest.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(AvisTest))
